function initWikiHover() {
    let display_time_out;

    function displayWiki(item) {
        hide_wiki();
        const id = item.attr('data-id');
        item.append('<div class="wiki_wrapper"><div class="wiki_content loading"></div>');
        $.ajax({
            url: `/api/v1/wiki/${id}`,
            method: 'get',
        }).done(response => {
            const icon = response.data.icon ? (
                `<div class="icon"><img src="${response.data.icon.url}" alt="${response.data.title}"></div>`
            ) : "";
            $('.wiki_wrapper .wiki_content').html(
                `<div class="slogan">دانشنامه واژگان تخصصی پدینی‌مارکت</div>` +
                `<div class="head"><div class="title">${response.data.title}</div>${icon}</div>` +
                `<div class="body">${response.data.text}</div>`
            ).removeClass('loading');
        });
    }

    function hide_wiki() {
        clearTimeout(display_time_out);
        $('.text_has_wiki').removeClass('open');
        $('.wiki_wrapper').remove();
    }

    $('.text_has_wiki').off('mouseenter.wiki mouseleave.wiki').hover(function () {
        if ($(this).hasClass('open')) {
            return;
        }
        display_time_out = setTimeout(() => {
            $(this).addClass('open');
            displayWiki($(this));
        }, 1000);
    }, function () {
        hide_wiki();
    });
}

document.addEventListener("page:load", initWikiHover);
